const { push: Push } = require('connected-react-router');
const { connect } = require('react-redux');
const { context } = require('app-context');
const EditInterests = require('../components/EditInterests');
const { safeWarning } = require('assertions-simplified');

const selectors = context.selectors.all;
const actions   = context.actions;
const redux     = context.redux.hooks;

const internals = {};

internals.sanitizeInterestDetails = (interestDetails = {}) => {

    const interests = Array.isArray(interestDetails.interests) ? interestDetails.interests : [];
    const interestIds = new Set(interests.map(({ id }) => id));
    const passionInterests = Array.isArray(interestDetails.passionInterests)
        ? interestDetails.passionInterests.filter(({ id }) => interestIds.has(id))
        : [];

    return {
        ...interestDetails,
        interests,
        passionInterests
    };
};

module.exports = connect(
    (state) => ({
        interestsLoading: selectors.getIsLoadingInterests(state),
        signupDetails: selectors.getSignupDetails_forProfileEditPage(state)
    }), {
        onLoad: () => (dispatch, getState) => {

            const state = getState();
            const schoolId = selectors.getCurrentSchoolId(state);
            const entities = [];

            if (selectors.getIsLoadingInterests(state)) {
                entities.push('interests');
            }

            if (!selectors.getCategories(state)?.length) {
                entities.push('categories');
            }

            if (!entities.length) {
                return Promise.resolve();
            }

            return dispatch(actions.dataFetching.fetchAppEntities({
                entities,
                schoolId
            })).catch(safeWarning);
        },
        onSubmit: (interestDetails, redirectPath = '/app/welcome') => (dispatch) => { // eslint-disable-line

            const sanitizedInterestDetails = internals.sanitizeInterestDetails(interestDetails);

            dispatch(actions.app.setShouldRefreshSearch({ discover: true, group: true }));

            return dispatch(actions.profileManagement.updateProfile({
                interests: sanitizedInterestDetails.interests.map(({ id }) => id),
                passionInterests: sanitizedInterestDetails.passionInterests.map(({ id }) => id)
            }))
                .then((success) => {

                    // The action creator resolves undefined on failure
                    if (!success) {
                        throw new Error('Update profile failed');
                    }

                    dispatch(Push(redirectPath));

                    dispatch(actions.alerts.notification.push({
                        message: 'Interests updated'
                    }));
                })
                .catch(safeWarning);
        },
        onSubmitNoRedirect: (interestDetails) => (dispatch) => { // eslint-disable-line

            const sanitizedInterestDetails = internals.sanitizeInterestDetails(interestDetails);
            const profileDiff = selectors.getUserProfileDiff_forUpdateProfile(redux.getState(), sanitizedInterestDetails);

            dispatch(actions.app.setShouldRefreshSearch({ discover: true, group: true }));

            return dispatch(actions.profileManagement.updateProfile(profileDiff))
                .then((success) => {

                    // The action creator resolves undefined on failure
                    if (!success) {
                        throw new Error('Update interests failed');
                    }

                    dispatch(actions.alerts.notification.push({
                        message: 'Interests updated'
                    }));
                })
                .catch(safeWarning);
        },
        onInvalidSubmit: () => actions.alerts.notification.push({ message: 'Please fix invalid form fields' })
    }
)(EditInterests);
